class HiyoUnwindBanner extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('[data-hiyo-parallax-media]');
    this.strength = Number.parseFloat(this.dataset.parallaxStrength || '0');
    this.abortController = new AbortController();

    if (!this.media || this.strength <= 0) return;

    const { signal } = this.abortController;
    const pageWrapper = document.querySelector('.page-wrapper');

    window.addEventListener('scroll', this.queueUpdate, { passive: true, signal });
    window.addEventListener('resize', this.queueUpdate, { passive: true, signal });
    pageWrapper?.addEventListener('scroll', this.queueUpdate, { passive: true, signal });

    this.resizeObserver = new ResizeObserver(this.queueUpdate);
    this.resizeObserver.observe(this);

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
        if (this.isVisible) this.queueUpdate();
      },
      { rootMargin: '20% 0px' }
    );
    this.intersectionObserver.observe(this);

    this.isVisible = true;
    this.updateParallax();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
    cancelAnimationFrame(this.updateFrame);
  }

  queueUpdate = () => {
    cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.updateParallax());
  };

  updateParallax() {
    if (!this.media || !this.isVisible) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.media.style.setProperty('--hiyo-unwind-parallax-offset', '0px');
      return;
    }

    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const sectionCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const normalizedDistance = (sectionCenter - viewportCenter) / (viewportHeight + rect.height);
    const offset = normalizedDistance * rect.height * this.strength;

    this.media.style.setProperty('--hiyo-unwind-parallax-offset', `${offset.toFixed(2)}px`);
  }
}

if (!customElements.get('hiyo-unwind-banner')) {
  customElements.define('hiyo-unwind-banner', HiyoUnwindBanner);
}
